import Marquee from "react-fast-marquee";
import { SERVICE_OPTIONS } from "../../lib/site";

export const MarqueeStrip = () => (
  <section className="relative bg-brand-orange py-5 border-y border-black/10 overflow-hidden" data-testid="marquee-strip">
    <Marquee speed={45} gradient={false} autoFill>
      {SERVICE_OPTIONS.map((s) => (
        <div key={s} className="flex items-center">
          <span className="font-display uppercase tracking-tight text-2xl sm:text-3xl text-forest px-6">{s}</span>
          <span className="text-forest/50 text-2xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
